import React, { useEffect, useMemo, useState } from "react";
import Cookies from "js-cookie";

const sectionTitleStyle = {
  fontFamily: "Poppins, sans-serif",
  fontWeight: 700,
  fontSize: "20px",
  color: "#142C44",
  marginBottom: "12px",
};

const subTextStyle = {
  fontFamily: "Manrope, sans-serif",
  fontWeight: 600,
  fontSize: "12px",
  color: "rgba(0,0,0,0.45)",
  margin: 0,
};

const valueTextStyle = {
  fontFamily: "Manrope, sans-serif",
  fontWeight: 800,
  fontSize: "16px",
  color: "rgba(0,0,0,0.65)",
  margin: "2px 0 12px 0",
};

const formatCurrency = (value) => {
  const num = Number(value);
  if (Number.isNaN(num)) return "-";
  return num.toLocaleString("en-US", {
    style: "currency",
    currency: "SGD",
    maximumFractionDigits: 0,
  });
};

const getInitials = (name = "SL") => {
  const textToSplit = String(name).split(" ");
  return (
    (textToSplit?.[0]?.[0] || "S").toUpperCase() +
    ((textToSplit?.[1]?.[0] || "L").toUpperCase() || "")
  );
};

const ActivityItem = ({ title, subtitle }) => (
  <div
    style={{
      width: "100%",
      textAlign: "left",
      marginBottom: "7px",
      borderRadius: "12px",
      backgroundColor: "#FFFFFFB3",
      padding: "12px",
    }}
  >
    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
      <div
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          background: "rgb(140,140,170)",
          marginRight: "10px",
          marginLeft: "5px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
          fontSize: 20,
          fontWeight: 600,
        }}
      >
        {getInitials(title)}
      </div>
      <div style={{ width: "calc(100% - 75px)" }}>
        <h3
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: 700,
            fontSize: "13px",
            color: "#435669",
            margin: "0px",
          }}
        >
          {title}
        </h3>
        <p
          style={{
            fontFamily: "Manrope, sans-serif",
            fontWeight: 600,
            fontSize: "11px",
            color: "rgba(0,0,0,0.4)",
            margin: "0px",
          }}
        >
          {subtitle}
        </p>
      </div>
    </div>
  </div>
);

const EmptyState = ({ text }) => (
  <div
    style={{
      width: "100%",
      padding: "0px 0px",
    }}
  >
    <div
      style={{
        width: "100%",
        padding: "0px 15px",
        background: "rgba(255,255,255,0.7)",
        borderRadius: "12px",
        height: "150px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Manrope, sans-serif",
        fontSize: "0.8em",
        fontWeight: 600,
        color: "#00000066",
      }}
    >
      {text}
    </div>
  </div>
);

const RedFlagCard = ({ loan, onApprove }) => (
  <div
    style={{
      background: "#ffffffb3",
      borderRadius: "12px",
      padding: "16px",
      minHeight: "295px",
      border: "1px solid rgba(14,90,165,0.08)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
    }}
  >
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "8px",
        }}
      >
        <div
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: 700,
            fontSize: "16px",
            color: "#142C44CC",
            margin: 0,
          }}
        >
          {loan.principal_name || "-"}
        </div>
        <span
          style={{
            background: "#FFF4E9",
            color: "#B26700",
            borderRadius: "999px",
            padding: "4px 10px",
            fontFamily: "Manrope, sans-serif",
            fontWeight: 700,
            fontSize: "12px",
            whiteSpace: "nowrap",
            height: "fit-content",
          }}
        >
          Red Flagged
        </span>
      </div>

      <p style={subTextStyle}>Loan ID</p>
      <p style={valueTextStyle}>{loan.loan_id || "-"}</p>

      <p style={subTextStyle}>Requested Amount</p>
      <p style={valueTextStyle}>{formatCurrency(loan.request_amount)}</p>

      <p style={subTextStyle}>Preferred Tenor</p>
      <p style={valueTextStyle}>
        {loan.request_period ? `${loan.request_period} Months` : "-"}
      </p>
    </div>

    <div style={{ width: "100%" }}>
      <button
        onClick={() => onApprove(loan.loan_id)}
        style={{
          marginTop: "14px",
          width: "100%",
          border: "2px solid rgba(14, 90, 165, 0.2)",
          borderRadius: "14px",
          padding: "6px 10px",
          fontFamily: "Manrope, sans-serif",
          fontSize: "12px",
          fontWeight: 700,
          color: "#0e5aa5",
          background: "#f5fbff",
          cursor: "pointer",
        }}
      >
        Approve to Market
      </button>
    </div>
  </div>
);

const RedFlagged = () => {
  const [data, setData] = useState([]);
  const [dataActivityLog, setActivityLog] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/profile/viewActivityLog",
          {
            method: "GET",
            headers,
          },
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const result = await response.json();
        setActivityLog([...(result.all_activity_log || [])].reverse());
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/loan/viewLoanRequest",
          {
            headers: {
              Authorization: "Bearer " + Cookies.get("token"),
              Accept: "application/json",
            },
          },
        );
        const json = await response.json();
        setData(json["Requested Loan"] || []);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  const redFlaggedLoans = useMemo(
    () =>
      data.filter(
        (loan) => !loan.visibility && loan.corporate_structure === false,
      ),
    [data],
  );

  const pushToMarket = async (loanId) => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/visibleLoanRequest?loan_id=${loanId}&visibility=1`,
        {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + Cookies.get("token"),
            Accept: "application/json",
          },
        },
      );
      if (!response.ok) {
        throw new Error("Unable to approve loan to market.");
      }
      setData((current) =>
        current.map((loan) =>
          loan.loan_id === loanId ? { ...loan, visibility: 1 } : loan,
        ),
      );
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        height: "91vh",
        display: "flex",
        gap: "20px",
      }}
    >
      <div
        style={{
          width: "75%",
          height: "100%",
          padding: "4px 0px 20px 20px",
        }}
      >
        <div
          style={{
            height: "100%",
            borderRadius: "10px",
            background:
              "transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
            padding: "15px",
          }}
        >
          <h2 style={sectionTitleStyle}>Red Flagged Loans</h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
              gap: "14px",
            }}
          >
            {redFlaggedLoans.length === 0 ? (
              <EmptyState text="No loans pending your approval" />
            ) : (
              redFlaggedLoans.map((loan) => (
                <RedFlagCard
                  key={loan.loan_id}
                  loan={loan}
                  onApprove={pushToMarket}
                />
              ))
            )}
          </div>
        </div>
      </div>
      <div
        style={{
          width: "25%",
          height: "100%",
          padding: "4px 20px 20px 0px",
        }}
      >
        <div
          style={{
            height: "100%",
            borderRadius: "10px",
            background:
              "transparent linear-gradient(0deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
            padding: "15px",
          }}
        >
          <div
            style={{
              color: "#142C44CC",
              fontSize: "18px",
              fontFamily: "Manrope, sans-serif",
              fontWeight: 800,
            }}
          >
            User Activity Log
          </div>
          <div style={{ height: "78vh", overflowY: "auto", marginTop: "15px" }}>
            {dataActivityLog && dataActivityLog.length > 0 ? (
              dataActivityLog.slice(0, 8).map((item, index) => (
                <ActivityItem
                  key={index}
                  title={
                    item.user_id?.[0] === "L"
                      ? item.principal_name
                      : item.entity_name || item.principal_name || "-"
                  }
                  subtitle={item.description || "-"}
                />
              ))
            ) : (
              <EmptyState text="No activity log records" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedFlagged;
